<ng-container *transloco="let t; prefix:'settings'">
  @if (accountService.currentUser(); as user) {

    @if(!navService.sideNavCollapsedSignal()) {
      <div class="preference side-nav-container"  [ngClass]="{
      'closed' : navService.sideNavCollapsedSignal(),
      'hidden': !navService.sideNavVisibilitySignal(),
      'no-donate': licenseService.hasActiveLicense()
      }">
        <div class="side-nav">

          @for(section of sections; track section.title + section.children.length; let idx = $index;) {
            @let children = getVisibleChildren(user, section);

            @if (children.length > 0) {
              <h5 class="side-nav-header mb-2" [ngClass]="{'mt-4': idx > 0}">{{t(section.title)}}</h5>
              @for(item of children; track item.fragment) {
                <app-side-nav-item [id]="'nav-item-' + item.fragment" [noIcon]="true" link="/settings" [fragment]="item.fragment" [title]="item.fragment | settingFragment" [badgeCount]="item.badgeCount?.() ?? 0" />
              }
            }
          }

        </div>
      </div>
      @if (breakpointService.isTabletOrBelow()) {
        <div class="side-nav-overlay" (click)="collapse()" [ngClass]="{'closed' : navService.sideNavCollapsedSignal()}"></div>
      }
    }

  }

</ng-container>
